import { z } from "zod";

/** Beitrag im Blog: Entwürfe sieht nur der Super-Admin, veröffentlichte Beiträge stehen auf der Website. */
export const blogPostSchema = z.object({
  title: z.string().trim().min(3, "Bitte geben Sie dem Beitrag eine Überschrift (mindestens 3 Zeichen).").max(140, "Die Überschrift darf höchstens 140 Zeichen lang sein."),
  excerpt: z.string().trim().max(300, "Der Teaser darf höchstens 300 Zeichen lang sein.").default(""),
  body: z.string().trim().min(1, "Bitte schreiben Sie einen Text.").max(30000, "Der Text ist zu lang (höchstens 30.000 Zeichen)."),
  published: z.boolean().default(false),
});
export type BlogPostInput = z.infer<typeof blogPostSchema>;

export interface BlogSummary {
  slug: string;
  title: string;
  excerpt: string;
  publishedAt: string;
}

export interface BlogPostFull extends BlogSummary {
  body: string;
}

export interface AdminBlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  body: string;
  published: boolean;
  publishedAt: string | null;
  updatedAt: string;
}

/** Adressteil aus der Überschrift: kleingeschrieben, Umlaute aufgelöst, nur Buchstaben, Zahlen und Bindestriche. */
export function slugify(title: string): string {
  const slug = title
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
    .replace(/-+$/g, "");
  return slug || "beitrag";
}
